<template>
  <div>
    <el-dialog
      title="关联发票"
      :visible.sync="dialogVisible"
      width="900px">
      <div>
        <div class="upload-section">
          <el-button size="mini" @click="selectInvoice">选择发票</el-button>
        </div>
        
        <div class="file-list-section">
          <el-table
            :data="displayFileList"
            border
            style="width: 100%">
            <el-table-column prop="buyerName" label="发票抬头" min-width="200"></el-table-column>
            <el-table-column prop="invoiceNo" label="发票号码" min-width="200"></el-table-column>
           <el-table-column prop="type_name" label="发票类型" width="100"></el-table-column>
           <el-table-column prop="invoiceType_name" label="发票种类" width="100"></el-table-column>
           <el-table-column prop="invoiceDate" label="开票日期" width="100"></el-table-column>
           <el-table-column prop="withTaxAmount" label="含税金额" width="100"></el-table-column>
           <el-table-column prop="noTaxAmount" label="不含税金额" width="100"></el-table-column>
           <el-table-column prop="totalTax" label="税额" width="80"></el-table-column>
           <el-table-column prop="taxRate" label="税率" width="80"></el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button 
                  v-if="scope.row.editing" 
                  size="mini" 
                  type="success" 
                  @click="saveEdit(scope.row, scope.$index)">保存</el-button>
                <el-button 
                  v-else 
                  size="mini" 
                  type="primary" 
                  @click="editUrl(scope.row)">编辑</el-button>
                <el-button 
                  size="mini" 
                  type="danger" 
                  @click="handleDelete(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="file-footer">
        <el-button size="mini" @click="closeFun">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 发票选择弹窗 -->
    <el-dialog
      title="选择发票"
      :visible.sync="invoiceDialogVisible"
      width="900px">
      <div class="invoice-search">
        <el-form :inline="true">
          <el-form-item>
            <el-input
              size="mini"
              v-model="invoiceForm.title"
              placeholder="输入发票抬头搜索"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              size="mini"
              v-model="invoiceForm.invoiceNo"
              placeholder="输入发票号码搜索"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="searchInvoice">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <div class="invoice-table">
        <el-table
          :data="invoiceList"
          border
          style="width: 100%"
          :row-key="(row) => row.id"
          @selection-change="handleInvoiceSelectionChange"
        >
          <el-table-column type="selection" width="55" :selectable="canSelectInvoice"></el-table-column>
          <el-table-column prop="buyerName" label="发票抬头" min-width="150"></el-table-column>
          <el-table-column prop="invoiceNo" label="发票号码" width="120"></el-table-column>
          <el-table-column prop="invoiceCode" label="发票代码" width="120"></el-table-column>
          <el-table-column prop="type_name" label="发票类型" width="100"></el-table-column>
          <el-table-column prop="invoiceType_name" label="发票种类" width="100"></el-table-column>
          <el-table-column prop="invoiceDate" label="开票日期" width="100"></el-table-column>
          <el-table-column prop="withTaxAmount" label="含税金额" width="100"></el-table-column>
          <el-table-column prop="noTaxAmount" label="不含税金额" width="100"></el-table-column>
          <el-table-column prop="totalTax" label="税额" width="100"></el-table-column>
          <el-table-column prop="taxRate" label="税率" width="100"></el-table-column>
        </el-table>
      </div>
      
      <div class="invoice-footer">
        <el-pagination 
          background 
          layout="prev, pager, next" 
          :page-size="invoiceForm.pageSize"
          :total="invoiceTotalCount" 
          :current-page.sync="invoiceForm.page"
          @current-change="searchInvoice"
        ></el-pagination>
      </div>
      
      <div class="dialog-footer" style="margin-top: 20px; text-align: right;">
        <el-button size="mini" @click="invoiceDialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmInvoiceSelect">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Http from "../common/Http";

export default {
  name: "UploadFile",
  props: {
   
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      task_id: 0,
      callback_fun: undefined,
      // 发票选择弹窗相关
      invoiceDialogVisible: false,
      invoiceForm: {
        title: "",
        invoiceNo: "",
        user_id: 0,
        task_id: 0,
        buyerName: "",
        page: 1,
        pageSize: 10,
      },
      invoiceList: [],
      invoiceTotalCount: 0,
      selectedInvoices: [],
      invoiceTableRef: null,
    }
  },
  computed: {
    displayFileList() {
      return this.fileList.map((item, index) => ({
        ...item,
      }))
    }
  },
  methods: {
    initConfig() {
      this.fileList = []
      this.callback_fun = undefined
    },
    show(config, callback_fun) {
      this.fileList = config.fileList
      let that = this
      that.dialogVisible = true
      that.invoiceForm.user_id = config.user_id
      that.invoiceForm.task_id = config.task_id
      that.invoiceForm.buyerName = config.buyerName
      console.info(that.invoiceForm)
      console.info(this.fileList)
      
      if (typeof callback_fun === 'function') {
        that.callback_fun = callback_fun
      }
    },
    selectInvoice() {
      this.invoiceDialogVisible = true;
      this.invoiceForm.page = 1;
      this.selectedInvoices = [];
      this.searchInvoice();
    },
    searchInvoice() {
      console.info(this.invoiceForm)
      Http.get("flow/JsApi/getInvoiceList", this.invoiceForm, (backdata) => {
        if (backdata.code == 200) {
          this.invoiceList = backdata.data;
          this.invoiceTotalCount = backdata.totalCount;
          this.invoiceForm.page = backdata.page;
        } else {
          this.$message.error(backdata.msg);
        }
      });
    },
    handleInvoiceSelectionChange(val) {
      this.selectedInvoices = val;
    },
    canSelectInvoice(row) {
      console.info(row.buyerName)
      console.info(this.invoiceForm.buyerName)
      console.info(row.buyerName !== this.invoiceForm.buyerName)
      return !row.buyerName || row.buyerName == this.invoiceForm.buyerName;
    },
    confirmInvoiceSelect() {
      if (!this.selectedInvoices || this.selectedInvoices.length === 0) {
        this.$message.warning("请选择发票");
        return;
      }
      
      let addedCount = 0;
      
      this.selectedInvoices.forEach((invoice) => {
        if (!invoice || !invoice.invoiceNo) {
          return;
        }
        const exists = this.fileList.some(item => item.name === invoice.invoiceNo);
        if (!exists) {
          this.fileList.push({
            name: invoice.invoiceNo,
            url: '',
            editing: false,
            invoice_id: invoice.id || '',
            buyerName: invoice.buyerName || '',
            invoiceCode: invoice.invoiceCode || '',
            type_name: invoice.type_name || '',
            invoiceDate: invoice.invoiceDate || '',
            withTaxAmount: invoice.withTaxAmount || 0,
            noTaxAmount: invoice.noTaxAmount || 0,
            invoiceType_name: invoice.invoiceType_name || '',
            invoiceType: invoice.invoiceType || '',
            totalTax: invoice.totalTax || 0,
            taxRate: invoice.taxRate || 0,
            original_image_id: invoice.original_image_id || 0,
            original_image_url: invoice.original_image_url || '',
            correction_image_id: invoice.correction_image_id || 0,
            correction_image_url: invoice.correction_image_url || '',
          });
          addedCount++;
        }
      });
      
      this.invoiceDialogVisible = false;
      this.selectedInvoices = [];
      
      if (addedCount > 0) {
        this.$message.success("已成功选择 " + addedCount + " 张发票");
      } else {
        this.$message.info("未添加新发票（所选发票已存在）");
      }
    },
    getTaskFile(){
      const that = this;
      let where={
        task_id: this.task_id,
      }
      Http.get("flow/FlowTaskFile/getList",{
        where:JSON.stringify(where),
        page: 1,
        page_size: 20
      },ret=>{
        if(ret.code){
          that.tableData=ret.data.list;
        }
      })
    },
    editUrl(row) {
      row.editing = true;
    },
    saveEdit(row, index) {
      row.editing = false;
      this.fileList[index] = { ...row };
    },
    handleDelete(row, index) {
      this.fileList.splice(index, 1);
    },
    confirmFun() {
      const result = JSON.stringify(this.fileList)
      
      if (typeof this.callback_fun === 'function') {
        this.callback_fun(result)
        this.callback_fun = undefined
      }
      this.dialogVisible = false
    },
    closeFun() {
      if (typeof this.callback_fun === 'function') {
        this.callback_fun = undefined
      }
      this.dialogVisible = false
    }
  },
  watch: {
    value(n) {
      if (n !== JSON.stringify(this.fileList)) {

      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-section {
  margin-bottom: 15px;
}

.upload-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}

.file-list-section {
  margin-top: 10px;
}

.url-text {
  word-break: break-all;
  color: #409EFF;
}

.file-footer {
  margin-top: 20px;
  width: 100%;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Flow/components/UploadFile.vue